import { createFileRoute } from '@tanstack/react-router'
import { RequireAuth } from '@dss/auth'
import { ProfileScreen } from '../features/me/ProfileScreen'

/** S26 — Профиль (расширенная карточка с edit + смена пароля + смена email). */
export const Route = createFileRoute('/profile')({
  component: ProfileRoute,
})

function ProfileRoute() {
  return (
    <RequireAuth>
      <ProfileScreen />
    </RequireAuth>
  )
}
